export default __webpack_public_path__ + "static/media/natcco@2x.2aa9e074.png";